import { ColumnChooserModel } from '../../models/common/ColumnChooserModel';

/**
 * Liste ekranlarının kolon düzeni tarayıcıda kullanıcıya özel saklanır.
 * Kayıtlı liste olduğu gibi döndürülürse, koda SONRADAN eklenen bir kolon
 * ekranı daha önce açmış kullanıcıda hiç görünmez (01.10.2026, "Not" kolonu).
 *
 * Bu işlem kullanıcının kendi düzenini korur ve yalnız eksik kolonları sona ekler:
 * sıra, gizlenen kolonlar ve kullanıcının yaptığı her şey yerinde kalır.
 *
 * Kayıt yoksa, bozuksa ya da boşsa varsayılan liste döner — ekran kolonsuz açılmaz.
 */
export const kolonlariBirlestir = (
    _varsayilanlar: ColumnChooserModel[],
    _kayitliJson: string | null | undefined
): ColumnChooserModel[] => {
    if (!_kayitliJson)
        return _varsayilanlar;

    let kayitli: ColumnChooserModel[];

    try {
        kayitli = JSON.parse(_kayitliJson);
    } catch {
        return _varsayilanlar;
    }

    if (!Array.isArray(kayitli) || kayitli.length == 0)
        return _varsayilanlar;

    const kayitliAdlar = kayitli.map(x => x?.name);
    const eksikler = _varsayilanlar.filter(x => !kayitliAdlar.includes(x.name));

    if (eksikler.length == 0)
        return kayitli;

    const sonSira = Math.max(0, ...kayitli.map(x => x?.order ?? 0));

    return [...kayitli, ...eksikler.map((x, i) => ({ ...x, order: sonSira + i + 1 }))];
}
